module.exports = __webpack_public_path__ + "img/25.55d92f19.png";